/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {BaseComponent, DamBasketInfo} from 'compob2b-libs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-basket-info',
  templateUrl: './basket-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketInfoComponent extends BaseComponent implements OnInit {

  dayInBasket = 30;

  ngOnInit() {
    this.compoApiService
      .get<DamBasketInfo>('/dam/basket-info')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.dayInBasket = response.data.dayInBasket;
        this.cdr.detectChanges();
      });
  }
}
